export default "__VITE_ASSET__Dl17zRug__"